import { Notification, NotificationsResponse } from '../../types/notification';
import axiosInstance from '../utils/axiosInstance';

export async function getNotifications(): Promise<Notification[]> {
  try {
    const response = await axiosInstance.get<NotificationsResponse>('/notifications');
    return response.data.notifications || [];
  } catch (error) {
    console.error('Error fetching notifications:', error);
    return [];
  }
}
